import { Card, Divider, Grid } from '@mui/material';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from '../../../../redux/store';
import { formCardStyle, scrollSX } from '../contractStyles';
import FormButtonOptions from './contract-form-fields/FormButtonOptions';
import FormMoneyField from './contract-form-fields/FormMoneyField';
import FormTextField from './contract-form-fields/FormTextField';
import FormTitle from './contract-form-fields/FormTitle';
import SectionHeader from './contract-form-fields/SectionHeader';

ContractTermsCard.propTypes = {
    isEditable: PropTypes.bool
}

export default function ContractTermsCard({ isEditable = false }) {
    const [focusedField, setFocusedField] = useState(null);
    const [open, setOpen] = useState(false);
    const { control } = useFormContext();

    const { contractOptions: { contractTypes = [] } = {} } = useSelector((state) => state.contracts || {});
    const selectedContractTypeId = useWatch({
        control,
        name: 'contractTypeId',
    });

    const selectedContractType = contractTypes.find((type) => String(type.id) === String(selectedContractTypeId));

    const getContractTypeQuestionTitle = (questionSuffix) =>
        selectedContractType?.[`question${questionSuffix}`];

    const answerOneTitle = getContractTypeQuestionTitle('One');
    const answerTwoTitle = getContractTypeQuestionTitle('Two');
    const answerThreeTitle = getContractTypeQuestionTitle('Three');
    const answerFourTitle = getContractTypeQuestionTitle('Four');
    const answerFiveTitle = getContractTypeQuestionTitle('Five');
    const invoiceEveryOptions = [
        'Month',
        'Quarter',
        'Year',
    ];
    const paymentTermsOptions = [
        'Weekly',
        '10 Days',
        '45 Days',
        '60 Days',
        '90 Days',
    ];

    return (
        <Card sx={{
            ...formCardStyle,
            ...scrollSX,
            maxHeight: open ? 'none' : '280px',
        }}>
            <SectionHeader title="Contract Terms" open={open} setOpen={setOpen} />
            <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />

            <Grid container spacing={1.5}>

                {answerOneTitle && (
                    <Grid item xs={12} >
                        <FormTitle title={answerOneTitle} />
                        <FormTextField
                            disabled={!isEditable}
                            fieldName={'answerOne'}
                            focusedField={focusedField}
                            setFocusedField={setFocusedField}
                        />
                    </Grid>
                )}

                {answerTwoTitle && (
                    <Grid item xs={12} >
                        <FormTitle title={answerTwoTitle} />
                        <FormTextField
                            disabled={!isEditable}
                            fieldName={'answerTwo'}
                            focusedField={focusedField}
                            setFocusedField={setFocusedField}
                        />
                    </Grid>
                )}

                {answerThreeTitle && (
                    <Grid item xs={12} >
                        <FormTitle title={answerThreeTitle} />
                        <FormTextField
                            disabled={!isEditable}
                            fieldName={'answerThree'}
                            focusedField={focusedField}
                            setFocusedField={setFocusedField}
                        />
                    </Grid>
                )}

                {answerFourTitle && (
                    <Grid item xs={12} >
                        <FormTitle title={answerFourTitle} />
                        <FormTextField
                            disabled={!isEditable}
                            fieldName={'answerFour'}
                            focusedField={focusedField}
                            setFocusedField={setFocusedField}
                        />
                    </Grid>
                )}

                {answerFiveTitle && (
                    <Grid item xs={12}>
                        <FormTitle title={answerFiveTitle} />
                        <FormTextField
                            disabled={!isEditable}
                            fieldName={'answerFive'}
                            focusedField={focusedField}
                            setFocusedField={setFocusedField}
                        />
                    </Grid>
                )}
                <Grid item xs={12} >
                    <FormTitle title='Amount' />
                    <FormMoneyField
                        disabled={!isEditable}
                        fieldName={'amount'}
                        focusedField={focusedField}
                        setFocusedField={setFocusedField}
                    />
                </Grid>
                <Grid item xs={12} >
                    <FormTitle title='Invoice Every' />
                    <FormButtonOptions
                        disabled={!isEditable}
                        fieldName={'invoiceEvery'}
                        options={invoiceEveryOptions}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormTitle title='Payment Terms' />
                    <FormButtonOptions
                        disabled={!isEditable}
                        fieldName={'paymentTerms'}
                        options={paymentTermsOptions}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormTitle title='Termination Clause With Cause' />
                    <FormTextField
                        disabled={!isEditable}
                        fieldName={'terminationClauseWithCause'}
                        focusedField={focusedField}
                        setFocusedField={setFocusedField}
                        placeholder="Enter clause"
                        multiline
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormTitle title='Termination Clause Without Cause' />
                    <FormTextField
                        disabled={!isEditable}
                        fieldName={'terminationClauseWithoutCause'}
                        focusedField={focusedField}
                        setFocusedField={setFocusedField}
                        placeholder="Enter clause"
                        multiline
                    />
                </Grid>
            </Grid>
        </Card>
    );
}



